module.exports = "@media (min-width: 992px) {\r\n    .header-1 { width: 10%;}\r\n    .header-8 { width: 80%;}\r\n }"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/layouts/header-nav/header-nav.component.css
// module id = ./src/app/theme/layouts/header-nav/header-nav.component.css
// module chunks = main